import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaTooth, FaXRay, FaPrescriptionBottleAlt } from 'react-icons/fa';
import { BiClipboard, BiListUl, BiCalendarEvent, BiDollar, BiChat, BiBarChart } from 'react-icons/bi';
import './Dashboard.css';

const Dashboard = () => {
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [userName, setUserName] = useState('');

    useEffect(() => {
        const token = localStorage.getItem('token');
        const userData = localStorage.getItem('user');
        
        if (!token) {
            navigate('/login');
            return;
        }
        
        if (userData) {
            const parsedUser = JSON.parse(userData);
            setUser(parsedUser);
            setUserName(parsedUser.fullname || 'User');
        }
    }, [navigate]);

    const handleLogout = () => {
        localStorage.clear();
        sessionStorage.clear();
        navigate('/doctors-admin-panel');
    };

    if (!user) {
        return <div className="loading">Loading...</div>;
    }

    return (
        <div className="dashboard-container">
            <div className="container">
                {/* Header with PanelNavbar and Logout */}
                <div className="row panel-header">
                </div>

                {/* 1. Dental History */}
                <div className="card mb-3 p-3">
                    <h5><FaTooth className="me-2" /> Dental History</h5>
                    <p><strong>Previous Treatments:</strong> Fillings, Extractions, Root Canal</p>
                    <p><strong>Allergies:</strong> Latex, Penicillin</p>
                    <p><strong>Oral Health Issues:</strong> Cavities, Gum Disease</p>
                </div>

                {/* 2. Current Dental Condition */}
                <div className="card mb-3 p-3">
                    <h5><BiClipboard className="me-2" /> Current Dental Condition</h5>
                    <p><strong>Diagnosis:</strong> Tooth Decay, Gingivitis</p>
                    <p><strong>Tooth Number:</strong> #18, #27, #14</p>
                    <p><strong>Notes:</strong> Sensitivity Reported, Pain on chewing</p>
                </div>

                {/* 3. Treatment Plan */}
                <div className="card mb-3 p-3">
                    <h5><BiListUl className="me-2" /> Treatment Plan</h5>
                    <p><strong>Procedures:</strong> Root Canal, Crown Placement, Scaling</p>
                    <p><strong>Estimated Cost:</strong> $1,200</p>
                    <p><strong>Duration:</strong> 3 Visits (2 weeks)</p>
                </div>

                {/* 4. Dental X-Rays & Imaging */}
                <div className="card mb-3 p-3">
                    <h5><FaXRay className="me-2" /> Dental X-Rays & Imaging</h5>
                    <p><strong>Last X-Ray Date:</strong> April 15, 2024</p>
                    <p><strong>Findings:</strong> Cavity in #14, Impacted wisdom tooth</p>
                    <p><strong>Images:</strong> <a href="#">View X-Ray Files</a></p>
                </div>

                {/* 5. Prescriptions */}
                <div className="card mb-3 p-3">
                    <h5><FaPrescriptionBottleAlt className="me-2" /> Prescriptions</h5>
                    <p><strong>Medications:</strong> Amoxicillin 500mg, Ibuprofen 400mg</p>
                    <p><strong>Dosage:</strong> 1 tablet 3x daily</p>
                    <p><strong>Duration:</strong> 7 days</p>
                </div>

                {/* 6. Appointments */}
                <div className="card mb-3 p-3">
                    <h5><BiCalendarEvent className="me-2" /> Appointments</h5>
                    <p><strong>Upcoming:</strong> April 28, 2024 at 10:00 AM</p>
                    <p><strong>Previous:</strong> April 10, 2024 - Dental Cleaning</p>
                    <p><strong>Status:</strong> Confirmed</p>
                </div>

                {/* 7. Billing & Payments */}
                <div className="card mb-3 p-3">
                    <h5><BiDollar className="me-2" /> Billing & Payments</h5>
                    <p><strong>Total Due:</strong> $450</p>
                    <p><strong>Last Payment:</strong> April 5, 2024 - $200</p>
                    <p><strong>Insurance:</strong> Covered (80% after deductible)</p>
                </div>

                {/* 8. Notes & Observations */}
                <div className="card mb-3 p-3">
                    <h5><BiChat className="me-2" /> Notes & Observations</h5>
                    <p><strong>Dentist Notes:</strong> Patient prefers sedation for procedures</p>
                    <p><strong>Patient Feedback:</strong> Mild pain after extraction</p>
                    <p><strong>Recommendation:</strong> Follow up in 2 weeks</p>
                </div>

                {/* 9. Dental Health Trends */}
                <div className="card mb-3 p-3">
                    <h5><BiBarChart className="me-2" /> Dental Health Trends</h5>
                    <p><strong>Plaque Index:</strong> 2.3 (Improving)</p>
                    <p><strong>Gum Health:</strong> Moderate inflammation, improving</p>
                    <p><strong>Chart:</strong> <a href="#">View Oral Health Graph</a></p>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;